import { render, staticRenderFns } from "./CompanyPerson.vue?vue&type=template&id=6f58f753"
import script from "./CompanyPerson.vue?vue&type=script&lang=js"
export * from "./CompanyPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports